import reducer from 'src/utils/redux/reducer';
import {SET_USER} from './types';

// --- initialState ---

export const initialState = {};

// --- handlers ---

const handleSetInitial = () => initialState;

const handleSetUser = (state, action) => ({ ...(action.payload || initialState) });

const handlers = {
  'SET_INITIAL': handleSetInitial,
  [SET_USER]: handleSetUser,
};

// --- reducerFactory ---

export default flows => reducer({ initialState, handlers, flows });